import React from "react";

import { IgPaper } from "@intelligems/ig-theme";
import {
  OrganizationSummaryDto,
  StripeSubscriptionSummaryDto,
} from "@intelligems/ig-types";
import { Grid, Paper } from "@mui/material";
import { SubscriptionDetailsHeader } from "@src/features/admin/components/SubscriptionDetailsHeader";
import { StripeProductLinksTable } from "@src/features/admin/pages/agencies/components/Tables/StripeProductLinksTable/StripeProductLinksTable";
import { ProviderColors } from "@src/features/admin/pages/overview/components/Expansions/SubscriptionsPanel/Colors";
import { SettingsSection } from "@src/features/admin/pages/overview/components/Expansions/SubscriptionsPanel/SettingsSection/SettingsSection";

interface V2SubscriptionsPanelProps {
  subscription: StripeSubscriptionSummaryDto;
  adminOrg: OrganizationSummaryDto;
  v1?: boolean;
}

export const SubscriptionPanel = ({
  subscription,
  adminOrg,
  v1 = false,
}: V2SubscriptionsPanelProps) => {
  const color =
    subscription.billingProvider === "stripe"
      ? ProviderColors.stripe
      : ProviderColors.shopify;

  return (
    <IgPaper
      sx={{
        // borderRadius: "10px",
        // boxShadow: "none",
        backgroundColor: color.panelBackgroundColor,
        padding: "10px 20px 20px 20px",
      }}
    >
      <Grid
        container
        item
        direction={"column"}
        justifyContent={"start"}
        rowSpacing={2}
      >
        <SubscriptionDetailsHeader
          viewCharges={{
            subscriptionLinkId: subscription.id,
            organizationId: subscription.organizationId,
          }}
          stripeSubscriptionId={subscription.stripeSubscriptionId}
          isBalanceExceeded={subscription.isBalanceExceeded}
          status={subscription.status}
          stripeSubscriptionScheduleId={
            subscription.stripeSubscriptionScheduleId
          }
          cancelAt={subscription.cancelAt}
          autoScale={subscription.autoScale}
          v1={v1}
          coupon={
            subscription.coupon
              ? {
                  percentOff: subscription.coupon.percentOff || undefined,
                  amountOff: subscription.coupon.amountOff || undefined,
                }
              : undefined
          }
          orderCount={adminOrg.usages.ordersPerMonth}
          agencyId={
            adminOrg.agencies.length ? adminOrg.agencies[0].id : undefined
          }
        />
        <StripeProductLinksTable
          products={subscription.stripeProductLinks || []}
          backgroundColor={`${color.tableHeaderBackgroundColor} !important`}
        />
        {v1 ? null : (
          <SettingsSection
            subscriptionLink={subscription}
            orgSummary={adminOrg}
          />
        )}
      </Grid>
    </IgPaper>
  );
};
